import React, { useState, useEffect, useRef } from "react";
import styles from './ResetPage.module.css';
import { resetPasswordApi } from "../../config/resetPasswordApi";
import { Link } from "react-router-dom";
import { useHistory } from "react-router-dom";
import { ToastContainer, toast, Slide } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { BsCheckAll } from "react-icons/bs";
import { BiError } from "react-icons/bi";

export default function ResetPage(props) {
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const token = props.token

  const btn = useRef();

  const passwordValidation = /^[A-Za-z[0-9]\w{7,}$/;

  const history = useHistory()

  const handleSubmit = (e) => {
    e.preventDefault();

    if (passwordValidation.test(password) === false) {
        toast.error(
          <span style={{ display: "flex", alignItems: "center" }}>
            <BiError size="22" />
            &nbsp; Please Enter Valid Password!
          </span>,
          {
            position: "bottom-left",
            autoClose: 5000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: false,
            draggable: true,
            progress: undefined,
          }
        );
      } else {
        setLoading(true);
        btn.current.setAttribute("disabled", "disabled");
        const reset = async () => {
          const reset = await resetPasswordApi(token, password);
  
          if (reset.error) {
              toast.error(
                <span style={{ display: "flex", alignItems: "center" }}>
                  <BiError size="30" style={{marginRight: "10px"}} />
                  {reset.error.response.data.message}
                </span>,
                {
                  position: "bottom-left",
                  autoClose: 5000,
                  hideProgressBar: true,
                  closeOnClick: true,
                  pauseOnHover: false,
                  draggable: true,
                  progress: undefined,
                }
              );
  
              setLoading(false);
              btn.current.removeAttribute("disabled");
            }
          else if (reset.data) {
            toast.success(
              <span style={{ display: "flex", alignItems: "center" }}>
                <BsCheckAll size="30" style={{marginRight: "10px"}} />
                 Password Changed Successfully!
              </span>,
              {
                position: "bottom-left",
                autoClose: 5000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: true,
                progress: undefined,
              }
            );
            setPassword("");
  
            setLoading(false);
            btn.current.removeAttribute("disabled");

            setTimeout(function () {
                history.push("/login");
              }, 1000);
          }
        };
        reset();
      }
  };

  useEffect(()=>{
      if(token === null){
        history.push("/");
      }
  })

  return (
    <div className={styles.mainall}>
      <div className={styles.main}>
        <div className={styles.formCont}>
          <h1 className={styles.heading}>Reset Password</h1>
          <p className={styles.des}>
            Kindly enter new password below and we will reset your password.
          </p>
          <form onSubmit={(e) => handleSubmit(e)}>
            <input
              type="password"
              placeholder="New Password"
              value={password}
              className={styles.input}
              onChange={(e) => setPassword(e.target.value)}
            />
            <button type="submit" className={styles.login} ref={btn}>
              {loading ? (
                <div class="spinner-border" role="status"></div>
              ) : (
                "Reset password"
              )}
            </button>
          </form>
          <div className={styles.allgo}>
            <p className={styles.next}>
              Remember your details?{" "}
              <Link to="/login" className={styles.go}>
                Sign in here
              </Link>
            </p>
          </div>
        </div>
      </div>
      <ToastContainer
        transition={Slide}
        position="bottom-left"
        autoClose={5000}
        hideProgressBar
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover={false}
        className={styles.toasst}
      />
    </div>
  );
}
